import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Button, Typography } from '@mui/material'

import { ReactComponent as CalendarX } from '../../../../assets/icons/calendar-x.svg'
import { ReactComponent as RocketLaunch } from '../../../../assets/icons/rocket-launch.svg'
import { ReactComponent as Clock } from '../../../../assets/icons/clock.svg'
import useTranslations from '../../../../i18n/useTranslations'

import { PICKUP_OPTIONS } from './index'
import styles from './styles'
import { useEffect, useState } from 'react'

const propTypes = {
  children: PropTypes.node,
  isChoosePickupDateDisabled: PropTypes.bool,
  pickupSource: PropTypes.string,
  changePickupSource: PropTypes.func,
  fixedPickupTimeZone: PropTypes.shape({
    fromDate: PropTypes.date,
    toDate: PropTypes.date,
  }),
}

const Pickup = ({
  children,
  pickupSource,
  isChoosePickupDateDisabled = false,
  changePickupSource,
  fixedPickupTimeZone,
}) => {
  const t = useTranslations()

  useEffect(() => {
    if (fixedPickupTimeZone) changePickupSource(PICKUP_OPTIONS.fixedPickUp)
    else changePickupSource(PICKUP_OPTIONS.asap)
  }, [fixedPickupTimeZone])

  return (
    <Box component="section" sx={styles.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator')}
        sx={styles.title}
      >
        {t('shipping-send-form:title:pick-up-date')}
      </Typography>

      <Box sx={styles.buttonsWrapper}>
        <Button
          size="small"
          startIcon={<RocketLaunch weight="regular" />}
          disabled={isChoosePickupDateDisabled}
          variant={
            pickupSource === PICKUP_OPTIONS.asap ||
            pickupSource === PICKUP_OPTIONS.fixedPickUp
              ? 'contained'
              : 'outlined'
          }
          onClick={() =>
            changePickupSource(
              fixedPickupTimeZone
                ? PICKUP_OPTIONS.fixedPickUp
                : PICKUP_OPTIONS.asap,
            )
          }
        >
          {t(!!fixedPickupTimeZone ? 'message:fixedPickup' : 'message:asap')}
        </Button>
        <Button
          size="small"
          startIcon={<Clock weight="regular" />}
          // variant={isPickUpTimeSlotBtnActive ? 'contained' : 'outlined'}
          disabled={isChoosePickupDateDisabled}
          variant={
            pickupSource === PICKUP_OPTIONS.chooseDayAndHour
              ? 'contained'
              : 'outlined'
          }
          // disabled={pickupOptions?.length < 2}
          onClick={() => changePickupSource(PICKUP_OPTIONS.chooseDayAndHour)}
        >
          {t('action:want-choose-day-time')}
        </Button>
        {!fixedPickupTimeZone && (
          <Button
            size="small"
            startIcon={<CalendarX weight="regular" />}
            disabled={isChoosePickupDateDisabled}
            variant={
              pickupSource === PICKUP_OPTIONS.requestLater
                ? 'contained'
                : 'outlined'
            }
            onClick={() => changePickupSource(PICKUP_OPTIONS.requestLater)}
          >
            {t('action:request-later')}
          </Button>
        )}
      </Box>
      {children}
    </Box>
  )
}

Pickup.propTypes = propTypes

export default Pickup
